import {call, put, select, takeEvery} from '@redux-saga/core/effects';

import {getActiveTests, getIsAdobeScriptLoaded} from 'services/target';
import {callInterval} from 'store/sagaHelpers';

import {TargetActions} from './target.reducer';
import {
  activeTestsSelector,
  adobeScriptLoadedSelector,
} from './target.selectors';

export const WATCH_TARGET_TESTS_TIMER = 1000;

export function* updateTargetTests() {
  const activeTestsFromWindow = getActiveTests();
  const isAdobeScriptLoaded = getIsAdobeScriptLoaded();
  const activeTestsFromState = yield select(activeTestsSelector);
  const isAdobeScriptLoadedState = yield select(adobeScriptLoadedSelector);

  const testsNotInState = activeTestsFromWindow.filter(
    t => !activeTestsFromState.includes(t)
  );
  const isActiveTestsDifferent = testsNotInState.length > 0;

  if (
    isActiveTestsDifferent ||
    isAdobeScriptLoaded !== isAdobeScriptLoadedState
  ) {
    yield put(
      TargetActions.setTargetTests({
        adobeScriptLoaded: isAdobeScriptLoaded,
        activeTests: testsNotInState,
      })
    );
  }
}

export function* watchTargetTestsOnWindow() {
  const channel = yield call(callInterval, WATCH_TARGET_TESTS_TIMER);

  yield takeEvery(channel, updateTargetTests);
}
